import React, { useState } from "react";
import axios from "axios";
import { useSearchParams, Link, useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // 获取邮件里的重置 Token
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      setIsError(true);
      setMessage("Invalid link: Missing token.");
      return;
    }

    try {
      const response = await axios.post("/signup/reset-password", {
        token: token,
        new_password: newPassword
      });
      setIsError(false);
      setMessage(response.data.message || "Password reset successful!");
      setTimeout(() => navigate("/login"), 3000); // 3秒后自动去登录
    } catch (error) {
      setIsError(true);
      setMessage(error.response?.data?.detail || "Failed to reset password. Link may be expired.");
    }
  };

  return (
    <div className="login-wrapper">
      <h2>Set New Password</h2>
      {message && <p style={{ color: isError ? "red" : "green", marginBottom: "10px" }}>{message}</p>}

      <form onSubmit={handleSubmit} className="login-form">
        <div className="input-group">
          <input
            type="password"
            placeholder="Enter new password (min 8 chars)"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength="8"
          />
        </div>
        <button type="submit" disabled={!newPassword}>Update Password</button>
      </form>
    </div>
  );
};

export default ResetPassword;